const enum UserCenterEnum {
  MY_WALLET_BALANCE = "/system/wallet/balance",
  WITHDRAW = "/system/wallet/withdraw",
  TRANSACTION_DETAIL = "/system/wallet/order_list",
  TRADED_LIST = "/system/task/transactionRecordList",
  FIRM_RADED_LIST = "/firm/order/sellerOrder",
  AUTHENTICATION = "/login/authentication",
  QUERY_USER_INFO = "/login/queryYeezAccount", // 开户信息
  ASSESSMENT_REPORT_LIST = "/dataset/assessmentReportList",
  ORDER_AUDIT_LIST = "/order/apply/sellerAuditList",
  AUDIT_ORDER = "/order/apply/audit",
  READ_ALL = "/system/message/readAll",
  COUNT_NOT_READ = "/system/message/count_not_read",
  MESSAGE_LIST = "/system/message/list",
  DELETE_MESSAGE = "/system/message/delete",
  READ_MESSAGE = "/system/message/read",
  UPDATE_USER_INFO = "/login/updateUser",
  QUERY_USER_PERSONAL_INFO = "/login/getUserInfo",
  ASSESSMENT_REPORT_AUDIT = "/dataset/assessmentReportAudit",
  MY_REPORT = "/noInterception/myReport",
  QUIT_DISCOURSE = "/api/discourse/logout",
  QUIT_SSO = "/api/sso/logout",
  SUBMIT_CERTIFICATION = "/user/submit/firm/verify",
  SUBMIT_CERTIFICATION_ORDER = "/firm/order/saveOrder",
}
export default UserCenterEnum;
